import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";

import CloudDownload from "@material-ui/icons/CloudDownload";

const styles = theme => ({
  para: {
    fontSize: 16
  },
  button: {
    margin: theme.spacing.unit,
    fontSize: 16
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
});

const Gimp = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">Raster graphics</Typography>
      <Typography className={classes.para} paragraph>
        <Link href={"https://en.wikipedia.org/wiki/Raster_graphics"}>
          Raster graphics
        </Link>{" "}
        or bitmap image is a dot matrix data structure that represents a
        generally rectangular grid of pixels (points of color), viewable via a
        monitor, paper, or other display medium. A raster is technically
        characterized by the width and height of the image in pixels and by the
        number of bits per pixel (or color depth, which determines the number of
        colors it can represent).
      </Typography>

      <Typography variant="h4">GIMP</Typography>
      <Typography className={classes.para} paragraph>
        <Link href={"https://www.gimp.org/"}>Gimp</Link> is an acronym for GNU
        Image Manipulation Program. It is a freely distributed program for such
        tasks as photo retouching, image composition and image authoring.
      </Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./gimp/Screenshot_14.png"
            alt="gimp"
          />
        </div>{" "}
        <Button
          variant="contained"
          size="small"
          color="primary"
          className={classes.button}
          target="_blank"
          href={"./gimp/new-york-tiny-world.xcf"}
        >
          <CloudDownload className={classes.leftIcon} />
          Download gimp file
        </Button>
        <Button
          variant="contained"
          size="small"
          color="primary"
          className={classes.button}
          target="_blank"
          href={"./gimp/new-york-tiny-world.jpg"}
        >
          <CloudDownload className={classes.leftIcon} />
          Download jpg file
        </Button>
        <br />I wanted to create the 'Tiny World' effect. I found out a tutorial
        on YouTube to do just that. I selected an{" "}
        <Link
          target="_blank"
          href={
            "https://wallimpex.com/new-york-computer-wallpapers/6857395.html"
          }
        >
          image
        </Link>{" "}
        and opened it with GIMP. This effect is achieved by adding image to
        polar coordinates. This gimp feature is accessed as shown below.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./gimp/Screenshot_1.png"
            alt="gimp"
          />
        </div>{" "}
        <br />I used color picker to pick color of the outer most sky. Next, I
        created a layer and filled the layer with sky color. The new layer is
        pushed to background. Next, I used erase tool with 'Hardness 025' and
        large brush to smoothen the edges at the intersection of both layers
        content. Smudge tool and Clone tool was used to retouch where necessary.
        <br />
        <br />
        The animation below shows how I rendered the 'tiny world' effect by
        image manipulation.
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./gimp/gimp1.gif" alt="gimp" />
        </div>{" "}
        <br />
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Gimp);
